import {theme} from "../../theme";
export const csvUploader = {
    customButton: {
      height: "6vw",
      width: "6vw",
      background: "#fff",
      borderRadius: "50%",
      border: "1px solid #E7E7E7",
      filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
      textDecoration: "none",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    },
    customButtonIcon: {
      color: theme.palette.primary.main,
      fontSize: "1.5vw",
      display: "inherit",
    },
    customButtonLabel: {
      marginTop: "5px",
      fontSize: "0.7vw",
      textTransform: "uppercase",
      color: theme.palette.text.primary,
      lineHeight: 1.2,
    },
    csvUploader: {
      backgroundColor: "transparent",
    },
  
    csvUploaderInput: {
      fontSize: 0,
      position: "absolute",
      left: 0,
      top: 0,
      width: "0",
      height: "0",
      opacity: 0,
      cursor: "pointer",
    },
  
    csvUploaderLabel: {},
  };